/**
 * Admin.js
 * Author: Markus.van.Kempen@gmail.com
 * Date: 2nd Nov 2025
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getIcon } from '../utils/icons';
import './Admin.css';

const Admin = () => {
  const { logout } = useAuth();

  const handleLogout = () => {
    console.log('🚪 Admin: Logout clicked');
    logout();
  };

  return (
    <div className="admin-container container">
      <div className="admin-content content-card">
        <div className="admin-header">
          <h2>Admin Dashboard</h2>
          <button onClick={handleLogout} className="logout-btn">
            Logout
          </button>
        </div>
        <p>Select a section to manage:</p>
        <nav className="admin-nav">
          <Link to="/admin/orders" className="admin-nav-link">
            <h3>{getIcon('cart')} Order Management</h3>
            <p>View and manage customer orders, update order status, and track shipments.</p>
          </Link>
          <Link to="/admin/settings" className="admin-nav-link">
            <h3>{getIcon('settings')} Site Settings</h3>
            <p>Manage site-wide settings like inventory display.</p>
          </Link>
          <Link to="/admin/products" className="admin-nav-link">
            <h3>{getIcon('bundle')} Product Management</h3>
            <p>Add, edit, and delete products in your catalog.</p>
          </Link>
          <Link to="/admin/categories" className="admin-nav-link">
            <h3>📂 Category Management</h3>
            <p>Create and manage product categories with custom icons.</p>
          </Link>
          <Link to="/admin/shipping" className="admin-nav-link">
            <h3>🚚 Shipping & Tax Settings</h3>
            <p>Configure shipping rates and free shipping thresholds for different countries.</p>
          </Link>
          <Link to="/admin/users" className="admin-nav-link">
            <h3>{getIcon('login')} User Management</h3>
            <p>Manage user accounts, roles, and permissions.</p>
          </Link>
          <Link to="/admin/newsletter" className="admin-nav-link">
            <h3>{getIcon('email')} Newsletter Management</h3>
            <p>Create and manage newsletters for your customers and subscribers.</p>
          </Link>
          <Link to="/admin/assets" className="admin-nav-link">
            <h3>{getIcon('image')} Asset Management</h3>
            <p>Upload, organize, and manage images, music, and other files.</p>
          </Link>
          <Link to="/admin/visibility" className="admin-nav-link">
            <h3>{getIcon('view')} Page Visibility Control</h3>
            <p>Control which pages and features are visible to different user types.</p>
          </Link>
          <Link to="/admin/pages" className="admin-nav-link">
            <h3>{getIcon('document')} Page Management</h3>
            <p>Create and manage custom pages like product details, tune notations, ABC, and more.</p>
          </Link>
          <Link to="/admin/templates" className="admin-nav-link">
            <h3>📄 Page Templates</h3>
            <p>Manage the HTML templates used when creating tune pages and other content — edit directly from the admin UI instead of source code.</p>
          </Link>
          <Link to="/admin/tune-metadata" className="admin-nav-link">
            <h3>🎻 Tune Metadata Reviewer</h3>
            <p>Upload tune metadata CSV files, review missing composer/type/key/time fields, and export updates.</p>
          </Link>
          <Link to="/admin/order-reminders" className="admin-nav-link">
            <h3>{getIcon('bell')} Order Reminders</h3>
            <p>Configure automated email reminders for open orders - daily, weekly, or monthly.</p>
          </Link>
          <Link to="/admin/bug-reports" className="admin-nav-link">
            <h3>🐛 Bug Reports</h3>
            <p>View and manage bug reports submitted by users. Update status (open, pending, followup, closed).</p>
          </Link>
          <Link to="/admin/documentation" className="admin-nav-link">
            <h3>📚 Documentation</h3>
            <p>Complete technical documentation and end-user guides for order processing, refunds, product creation, tune management, and more.</p>
          </Link>
        </nav>
      </div>
    </div>
  );
};

export default Admin; 